import { AccountBalance, Add, Logout, NoteAdd, SupportAgent } from '@mui/icons-material';
import CampaignIcon from '@mui/icons-material/Campaign';
import ContactsIcon from '@mui/icons-material/Contacts';
import ContactSupportTwoToneIcon from '@mui/icons-material/ContactSupportTwoTone';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import TableChartTwoToneIcon from '@mui/icons-material/TableChartTwoTone';
import { Box, Button, Divider, List, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { Role, UserPlan, useUserQuery } from '../../api/gql';
import { Logo } from '../../components';
import { ClaimIcon, InvoiceIcon } from '../../components/icons/CustomIcons';
import { theme } from '../../style/theme';
import { AppVersion } from './components/AppVersion';
import { Content } from './components/Content';
import { AppDrawer } from './components/Drawer';
import { HeaderTag } from './components/HeaderTag';
import { CollapsibleListItemNavLink, ListItemNavLink } from './components/NavigationsLinks';

export const AppLayout = () => {
  const { t } = useTranslation();
  const { data } = useUserQuery();
  const plan = data?.user.plan;

  return (
    <Box component={'main'} display={'flex'} flexDirection={'row'} sx={{ flexDirection: { xs: 'column', sm: 'row' } }}>
      <AppDrawer>
        <Box p={4} position={'relative'}>
          <Link to={'/'}>
            <Logo width={'100%'} />
          </Link>
          {plan !== UserPlan.Trial && <HeaderTag text={plan === 'OPTIMAL' ? t('optimal') : t('complete')} />}
        </Box>
        <Box py={1} mx={1}>
          <Button
            component={Link}
            to={'/invoice-management/invoices/create'}
            size={'large'}
            variant={'contained'}
            startIcon={<NoteAdd />}
            fullWidth={true}
          >
            {t('newInvoice')}
          </Button>
        </Box>
        <Box pt={1} pb={2} mx={'auto'}>
          <Button component={Link} to={'/upload'} size={'large'} variant={'contained'} startIcon={<Add />}>
            {t('newReminding')}
          </Button>
        </Box>
        <List>
          <ListItemNavLink to={'/invoice-management/invoices'} icon={<InvoiceIcon />} text={t('invoice-management')} />
          <CollapsibleListItemNavLink
            to={'/'}
            text={t('dashboard')}
            icon={<TableChartTwoToneIcon />}
            defaultOpen={true}
          >
            <ListItemNavLink isNested to={'/invoices'} icon={<InvoiceIcon />} text={t('invoices.title')} />
            <ListItemNavLink isNested to={'/claims'} icon={<ClaimIcon />} text={t('claims.title')} />
          </CollapsibleListItemNavLink>
          <ListItemNavLink to={'/contacts'} icon={<ContactsIcon />} text={t('contacts')} />
          <ListItemNavLink to={'/reminding-tone'} icon={<CampaignIcon />} text={t('remindingTone.title')} />
          <ListItemNavLink to={'/bank-connection'} icon={<AccountBalance />} text={t('bankConnection.title')} />
          <ListItemNavLink to={'/support'} icon={<ContactSupportTwoToneIcon />} text={t('support')} />
        </List>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            justifyContent: 'flex-end',
          }}
        >
          <Divider />
          <ProfileSection />
          <AppVersion />
        </Box>
      </AppDrawer>
      <Content>
        <Outlet />
      </Content>
    </Box>
  );
};

const ProfileSection = () => {
  const { t } = useTranslation();
  const { data } = useUserQuery();
  return (
    <Box display={'flex'} flexDirection={'column'} width={'100%'} pb={0}>
      <Box px={1} pt={4} pb={2} width={'100%'} display={'flex'} flexDirection={'column'} gap={2} alignItems={'center'}>
        <Typography variant={'body2'} color={'secondary.light'}>
          {data?.user.firstName} {data?.user.lastName}
        </Typography>
      </Box>
      <List>
        {data?.user.role === Role.Admin ? (
          <ListItemNavLink to={'/admin'} text={t('administrator')} icon={<SupportAgent />} />
        ) : null}
        <ListItemNavLink to={'user-profile'} text={t('userProfile')} icon={<ManageAccountsIcon />} />
        <ListItemNavLink
          to={'/logout'}
          text={
            <Typography
              sx={{
                color: theme.palette.error.main,
              }}
            >
              {t('logout')}
            </Typography>
          }
          icon={<Logout color={'error'} fontSize="small" />}
        />
      </List>
    </Box>
  );
};
